export default {
  CONVERSATIONAL: 'conversational',
  DANGER: 'danger',
  DEFAULT: 'default',
  FULLSCREEN: 'fullscreen',
  INFO: 'info',
  SIDEBAR: 'sidebar',
  SUCCESS: 'success'
};